import { createUseStyles } from "react-jss";
import { COLORS } from "./defaults";

export const buttonStyles = {
    default: {
        fontSize: "unset",
        textAlign: "unset",
    },
    button: {
        margin: "0.2em",
        padding: "0.8em",
        border: "0 none",
        cursor: "pointer",
        borderRadius: "40px",
    },
    purpleBtn: {
        color: COLORS.primary.font,
        backgroundColor: COLORS.primary.main,

        "&:active,&:hover": {
            color: COLORS.primary.main,
            backgroundColor: "ghostwhite",
            boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
        },
    },
    cobrarBtn: {
        color: "#ffffff",
        backgroundColor: COLORS.primary.acept,

        "&:active,&:hover": {
            color: COLORS.primary.acept,
            backgroundColor: "ghostwhite",
            boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
        },
    },
    registerBtn: {
        color: COLORS.primary.light,
        backgroundColor: "#ffffff" ,
        border: `2px solid ${COLORS.primary.light}`,
        "&:active,&:hover": {
            color: COLORS.primary.acept,
            backgroundColor: "ghostwhite",
            boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
        },
    },
    transparentBtn: {
        color: COLORS.primary.font,
        backgroundColor: "transparent", // Fondo transparente
        // border: `1px solid ${COLORS.primary.acept}`, // Opcional: agrega un borde

        "&:hover, &:active": {
            backgroundColor: "rgba(0, 0, 0, 0.05)", // Un leve sombreado al pasar el mouse
            color: COLORS.primary.font,
            boxShadow: "none", // Elimina sombras fuertes si no las quieres
        },

        "&:disabled": {
            opacity: 0.5,
            cursor: "not-allowed",
            backgroundColor: "transparent",
        },
    },
    cardOption: {
        padding: "1em",
        cursor: "pointer",
        borderRadius: "1em",
        backgroundColor: "ghostwhite",

        "&:hover": {
            color: COLORS.primary.main,
            boxShadow: "0px 0px 1px 1px #6C8589"
        }
    },
    
    cardOptionMenu: {
        padding: "1em",
        cursor: "pointer",
        width: "100%",
        borderRadius: "0em",
        backgroundColor: "rgba(43, 42, 43, 0)",
        borderBottom: "1px solid #CCC",
        // "&:hover": {
        //     color: COLORS.primary.main,
        //     boxShadow: "0px 0px 1px 1px #6C8589"
        // }
    },
    marginTB1em: {
        marginTop: "1em",
        marginBottom: "1em"
    },
    alignBtnContent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    btnForward: { width: "90%" },
    btnFullwidth: { width: "100%" },
    btnBackward: { 
        position: 'absolute', 
        top: '1.9rem', 
        left: '1rem',
        width: "1.75rem", 
        height: "1.75rem",
        // minWidth: "1.5em" ,
        background: "transparent",
        color: "#ffffff"
    },
    cursorNormal: { cursor: "default" },
    buttonTransparent: {
        borderRadius: "25px",
        width: "95px",
        border: "2px solid black",
        padding: "5px",
        cursor: "pointer",
        "&:hover": {
            color: COLORS.primary.main,
            boxShadow: "0px 0px 1px 1px #99b83c"
        }
    }
};
export const buttonClasses = createUseStyles(buttonStyles);